module.exports = __webpack_public_path__ + "static/media/Services.fdd57a03.svg";